/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterPolicyMapping extends models.JiraDataCenterMappingBase {
    getFixupPrototypeFunction() { return JiraDataCenterPolicyMapping.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterPolicyMapping>): JiraDataCenterPolicyMapping {
        let obj = Object.assign(new JiraDataCenterPolicyMapping(), model);
        JiraDataCenterPolicyMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterPolicyMapping>): JiraDataCenterPolicyMapping {
        if (!model) return null;
        return JiraDataCenterPolicyMapping.newInstance(<JiraDataCenterPolicyMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterPolicyMapping) {
        if (!obj) return;

        models.JiraDataCenterPolicyMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterPolicyMapping): boolean {
        if (models.JiraDataCenterMappingBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraDataCenterPolicyMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.issue_type) {
            models.JiraDataCenterIssueType.fixupPrototype(this.issue_type);
        }
    }

    /**
     * IssueType attribute mapping for JIRA DataCenter
     */
    issue_type: models.JiraDataCenterIssueType;

    selected_description_attributes: Array<models.JiraDataCenterPolicyDescriptionAttribute>;

    selected_summary_attributes: Array<models.JiraDataCenterPolicySummaryAttribute>;

}
